import React from 'react';
import Chart from 'react-apexcharts';
import { Card, Typography, Box } from '@mui/material';

const ColumnChart = ({ title, series, categories }) => {
  // ApexCharts options for a basic column chart
  const chartOptions = {
    chart: {
      type: 'bar',
      height: 350,
      toolbar: {
        show: false, // Minimal toolbar for a basic chart
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '55%',
        borderRadius: 5,
        borderRadiusApplication: 'end',
      },
    },
    dataLabels: {
      enabled: false, // Disable data labels for a clean look
    },
    stroke: {
      show: true,
      width: 2,
      colors: ['transparent'],
    },
    xaxis: {
      categories: categories || [], // Use provided categories (dates)
      title: {
        text: 'Date',
        style: {
          fontSize: '12px',
          fontWeight: 600,
        },
      },
    },
    yaxis: {
      title: {
        text: 'Count',
        style: {
          fontSize: '12px',
          fontWeight: 600,
        },
      },
      min: 0, // Ensure y-axis starts at 0
    },
    fill: {
      opacity: 1,
    },
    colors: [
      '#4BC0C0', // NEW_FOLLOWERS (teal)
      '#36A2EB', // NET_FOLLOWERS (blue)
      '#FF6384', // PAGE_FAN_REMOVES_UNIQUE (pink)
    ],
    legend: {
      position: 'top',
      horizontalAlign: 'center',
    },
    tooltip: {
      y: {
        formatter: (val) => `${val} users`,
      },
    },
  };

  // Ensure series is in the correct format
  const chartSeries = series || [];

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', position: 'relative', height: '100%' }}>
      <Typography
        variant="h6"
        sx={{
          fontSize: '1.1rem',
          fontWeight: 600,
          color: '#1a2027',
          mb: 2,
          textAlign: 'center',
        }}
      >
        {title || 'Page Like Growth'}
      </Typography>
      <Chart
        options={chartOptions}
        series={chartSeries}
        type="bar"
        height={300}
        width="100%"
      />
    </Box>
  );
};

export default ColumnChart;